export * from '@primeuix/themes/lara/slider';
export { default } from '@primeuix/themes/lara/slider';
